"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaitori_history_items_mini_1 = __importDefault(require("~/components/single_products/kaitori_history_items_mini"));
var DEFAULT_INITIAL_SHOW_COUNT = 4;
var KaitoriHistoryItemsMiniRedesign = function (_a) {
    var histories = _a.histories, _b = _a.initialShowCount, initialShowCount = _b === void 0 ? DEFAULT_INITIAL_SHOW_COUNT : _b, _c = _a.showMoreLabel, showMoreLabel = _c === void 0 ? '▼事例をもっと見る' : _c, _d = _a.showLessLabel, showLessLabel = _d === void 0 ? '▲事例を閉じる' : _d;
    var _e = react_1.default.useState(false), expanded = _e[0], setExpanded = _e[1];
    var showCount = expanded ? histories.length : Math.max(0, initialShowCount);
    var hasMore = histories.length > initialShowCount;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaitori_history_items_mini_1.default, { histories: histories.slice(0, showCount) }),
        hasMore ? (react_1.default.createElement("button", { type: "button", className: "appraisal-history__more", onClick: function () { return setExpanded(function (prev) { return !prev; }); } }, expanded ? showLessLabel : showMoreLabel)) : null));
};
exports.default = KaitoriHistoryItemsMiniRedesign;
